import { defineComponent as _defineComponent } from 'vue'
import type { TravelInsuranceTraveller, LoungePassTraveller } from '../../../types.ts';
//components
import LoungePassAdditionalTravellerCard from './lounge-pass-additional-traveller-card.vue';
import TravelInsuranceAdditionalTravellerCard from './travel-insurance-additional-traveller-card.vue';

interface Props {
  travelInsuranceTravellers?: TravelInsuranceTraveller[];
  loungePassTravellers?: LoungePassTraveller[];
  hideTitle?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'additional-travellers-combined-product-summary',
  props: {
    travelInsuranceTravellers: { default: () => [] },
    loungePassTravellers: { default: () => [] },
    hideTitle: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { travelInsuranceTravellers: TravelInsuranceTraveller[], loungePassTravellers: LoungePassTraveller[], hideTitle: boolean };

//types


return { __sfc: true,props, LoungePassAdditionalTravellerCard, TravelInsuranceAdditionalTravellerCard }
}

})